import { useSelector } from 'react-redux';
import { List } from 'shared/components/List';
import { selectDealType } from 'shared/selectors/dealType';
import { TListProps } from 'shared/types/list';
import { ListItemContainer } from '../ListItem';
import { useDeviceType } from '@cian/ui-kit';
import { formatDeal, formatOffer } from './formatTypes';
import { selectOfferType } from 'shared/selectors/offerType';
import { EDealType } from 'shared/types/wantType';

type TListContainerProps = TListProps;

export const ListContainer: React.FC<TListContainerProps> = ({ list, caCategory }) => {
  const dealType = useSelector(selectDealType);

  const offerType = useSelector(selectOfferType);

  const device = useDeviceType();

  const title = `5 шагов к ${formatDeal(dealType)} ${formatOffer(offerType)} ${dealType === EDealType.Host ? 'посуточно' : ''}`;

  return (
    <List
      list={list}
      device={device}
      title={title}
      dealType={dealType}
      caCategory={caCategory}
      ListItem={ListItemContainer}
    />
  );
};
